<template>
    <div>
        <b-modal id="modal-accident-vehicle" class="maintenance_modal" centered :footer-class="'d-block p-3 m-0'"
            scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title"> {{ vehicleData ? $t('accidentVehicle.editTitle') : $t('accidentVehicle.addTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="d-block text-center">
                <b-row>
                    <b-col sm="12" class="text-left">
                        <b-form-group>
                            <label class="state">{{ $t('accidentVehicle.nameLabel') }}</label>
                            <b-form-input type="text" v-model="vehiclePayload.name" class="f-12" :placeholder="$t('accidentVehicle.namePlaceholder')"
                                :disabled="!allowUpdateRecord"></b-form-input>
                            <p v-if="errors && errors.name" class="field-error">
                                {{ errors.name[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('accidentVehicle.makeLabel') }}</label>
                            <b-form-input type="text" v-model="vehiclePayload.make" class="f-12" :placeholder="$t('accidentVehicle.makePlaceholder')"
                                :disabled="!allowUpdateRecord"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('accidentVehicle.typeLabel') }}</label>
                            <b-form-select v-model="vehiclePayload.type" class="f-12" :options="typeOptions" />
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('accidentVehicle.insuranceLabel') }}</label>
                            <b-form-input type="text" v-model="vehiclePayload.insurance" class="f-12"
                                :placeholder="$t('accidentVehicle.insurancePlaceholder')" :disabled="!allowUpdateRecord"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('accidentVehicle.policyLabel') }}</label>
                            <b-form-input type="text" v-model="vehiclePayload.policy_no" class="f-12"
                                :placeholder="$t('accidentVehicle.policyPlaceholder')" :disabled="!allowUpdateRecord"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('accidentVehicle.towLabel') }}</label>
                            <b-form-select v-model="vehiclePayload.tow" class="f-12" :options="towOptions" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0">
                    <b-button class="mt-3 mr-3 btn cancel m-0" block @click="resetPopup()">{{ $t('safetyShared.cancel') }}</b-button>
                    <div class="d-flex align-items mt-3 m-0">
                        <b-button class="btn save mx-0 w-100" variant="primary" @click="onAddVehicle"
                            v-if="allowUpdateRecord">{{ $t('safetyShared.save') }}</b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    name: "AccidentVehicle",
    props: ["id", "vehicleData", "addVehicle", 'updateVehicle', 'allowUpdateRecord'],
    computed: {
        typeOptions() {
            return [
                { value: '', text: '-' },
                { value: 'Truck', text: this.$t('accidentVehicle.typeTruck') },
                { value: 'Trailer', text: this.$t('accidentVehicle.typeTrailer') },
                { value: 'Car', text: this.$t('accidentVehicle.typeCar') },
                { value: 'SUV', text: this.$t('accidentVehicle.typeSuv') },
                { value: 'Pickup Truck', text: this.$t('accidentVehicle.typePickup') },
                { value: 'Other', text: this.$t('accidentVehicle.typeOther') },
            ];
        },
        towOptions() {
            return [
                { value: null, text: '-' },
                { value: true, text: this.$t('accidentVehicle.yes') },
                { value: false, text: this.$t('accidentVehicle.no') },
            ];
        },
    },
    data() {
        return {
            errors: {},
            vehiclePayload: {
                name: "",
                make: "",
                type: "",
                insurance: "",
                policy_no: "",
                tow: null
            },
        }
    },
    methods: {
        ...mapActions(['setNotification', 'setLoader']),
        resetPopup() {
            this.errors = {}
            this.vehiclePayload = {
                name: "",
                make: "",
                type: "",
                insurance: "",
                policy_no: "",
                tow: null
            }
            this.$emit("popupClose")
            this.$bvModal.hide("modal-accident-vehicle");
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async onAddVehicle() {
            try {
                const nullKeys = this.checkNullValues({
                    name: this.vehiclePayload.name
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    let successMsg = this.$t('accidentVehicle.vehicleAdded')
                    if (this.vehicleData) {
                        await this.updateVehicle({ id: this.id, payload: { ...this.vehiclePayload, id: this.vehicleData.id } })
                        successMsg = this.$t('accidentVehicle.vehicleUpdated')
                    }
                    else await this.addVehicle({ id: this.id, payload: this.vehiclePayload })
                    await this.setNotification({
                        msg: successMsg,
                        type: "success",
                        color: "green",
                    });
                    this.$emit("vehicleUpdated", true)
                    this.resetPopup()
                    this.setLoader(false)
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('safetyShared.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false);
            }
        }
    },
    watch: {
        vehicleData() {
            if (this.vehicleData) {
                this.vehiclePayload = JSON.parse(JSON.stringify(this.vehicleData))
            }
        }
    }
}
</script>